import { DisplayBillState } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { SelectField } from '@mews-commander/form';
import { TextKey } from '@mews-commander/enums';
import { useGetSelectOptions } from '../../../common/hooks';

const mapInvoiceStatusTypes = {
    [DisplayBillState.Overdue]: TextKey.Overdue,
    [DisplayBillState.PartiallyPaid]: TextKey.PartiallyPaid,
    [DisplayBillState.Unpaid]: TextKey.Unpaid,
};

export const InvoiceStatusFilter = ({ name }: { name: string }) => {
    const invoiceStatusOptions = useGetSelectOptions(mapInvoiceStatusTypes);
    return (
        <SelectField
            data-test-id="invoice-status-filter"
            name={name}
            options={invoiceStatusOptions}
            multiselect
            virtualized
            label={<LocalizedText textKey={TextKey.InvoiceStatus} />}
        />
    );
};
